import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import Footer from "../ones/Footer";
import ServicesContent from "../ones/ServicesContent";
import CallToAction from "../ones/CallToAction";

export default function ServicesLanding() {
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (ready) {
    return (
      <>
        <ServicesContent />
        <CallToAction />
        <Footer />
      </>
    );
  }

  return <div className="container mSupportLoading">{getInlineLoader()}</div>;
}
